import { ChevronRight, Sparkles, Zap, TrendingUp, Gift, Baby } from 'lucide-react';

const CategoryButtons = () => {
  const buttons = [
    { label: 'Ofertas Relampago', href: '#flash', color: '#FF4500', icon: Zap },
    { label: 'Achadinhos do Dia', href: '#produtos', color: '#1a2744', icon: Sparkles },
    { label: 'Produtos Virais', href: '#virais', color: '#2563eb', icon: TrendingUp },
    { label: 'Infantil', href: '#criancas', color: '#FF69B4', icon: Baby },
    { label: 'Ver Tudo', href: '/ofertas', color: '#16a34a', icon: Gift },
  ];

  return (
    <section className="py-6 md:py-8 bg-[#f8fafc]" data-testid="category-buttons">
      <div className="container mx-auto px-4 max-w-5xl">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-3 md:gap-4">
          {buttons.map((btn) => (
            <a
              key={btn.label}
              href={btn.href}
              className="flex items-center justify-center gap-2.5 text-white font-bold text-base sm:text-base md:text-lg py-5 sm:py-5 md:py-6 px-5 sm:px-5 md:px-6 rounded-lg shadow-md hover:shadow-xl hover:-translate-y-1.5 transition-all duration-300 ease-out"
              style={{ backgroundColor: btn.color }}
              data-testid={`cat-btn-${btn.label.toLowerCase().replace(/\s/g, '-')}`}
            >
              <btn.icon className="w-5 h-5 sm:w-6 sm:h-6" />
              <span>{btn.label}</span>
              <ChevronRight className="w-4 h-4 sm:w-5 sm:h-5" />
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CategoryButtons;
